var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"depressed":"","small":"","color":"primary","disabled":_vm.disabled,"block":_vm.block,"loading":_vm.loading},on:{"click":_vm.save}},[_vm._m(0),_vm._m(1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"small":"","left":""}},[_vm._v(_vm._s(_vm.icon || "save"))])
},function (){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.label || "Save"))])
}]

export { render, staticRenderFns }